import { FilteredItemProps } from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';

import { EmspBoLocationCityFilterStateController } from '../emsp-bo-location-city-filter-state/emsp-bo-location-city-filter-state.controller';
import { EmspBoLocationCountryFilterStateController } from '../emsp-bo-location-country-filter-state/emsp-bo-location-country-filter-state.controller';
import { EmspBoLocationCpoIdFilterStateController } from '../emsp-bo-location-cpo-id-filter-state/emsp-bo-location-cpo-id-filter-state.controller';
import { EmspBoLocationNameFilterStateController } from '../emsp-bo-location-name-filter-state/emsp-bo-location-name-filter-state.controller';

export const EMSP_BO_EMSP_LOCATION_LIST_SORT_FIELD: NonNullable<
  GetLocationsPaginatedModel['sortField']
> = 'updatedAt';

export const EMSP_BO_EMSP_LOCATION_LIST_SORT_ORDER: NonNullable<
  GetLocationsPaginatedModel['sortOrder']
> = 1;

type ResourceListFilter = Partial<
  Record<
    keyof GetLocationsPaginatedModel,
    {
      componentType: React.ComponentType<{
        value: any;
        onRemove: FilteredItemProps['onRemove'];
      }>;
    }
  >
>;

export const EMSP_BO_LOCATION_LIST_FILTER: ResourceListFilter = {
  cpoId: {
    componentType: EmspBoLocationCpoIdFilterStateController,
  },
  country: {
    componentType: EmspBoLocationCountryFilterStateController,
  },
  city: {
    componentType: EmspBoLocationCityFilterStateController,
  },
  name: {
    componentType: EmspBoLocationNameFilterStateController,
  },
} as const;

export const EMSP_BO_LOCATION_LIST_FILTER_NAME_LIST = Object.keys(
  EMSP_BO_LOCATION_LIST_FILTER,
) as Array<keyof typeof EMSP_BO_LOCATION_LIST_FILTER>;
